<script lang="ts" setup generic="T extends string | number | symbol">
import type { AppMultiSelectOption } from '../models/multi.model';
import AppSvgIcon from '../../appSvgIcon/AppSvgIcon.vue';
import AppRawButton from '../../appRawButton/AppRawButton.vue';

interface AppMultiSelectItem<T> {
  item: AppMultiSelectOption<T>;
}

const props = defineProps<AppMultiSelectItem<T>>();

interface AppMultiSelectItemEmits<T> {
  (eventName: 'select', value: AppMultiSelectOption<T>): void;
}

const emit = defineEmits<AppMultiSelectItemEmits<T>>();
</script>

<template>
  <AppRawButton
    class="app-multi-select-dropdown-item"
    :class="{
      disabled: props.item.disabled,
      selected: props.item.selected,
    }"
    @click="emit('select', props.item)"
  >
    <div class="app-multi-select-dropdown-item-checkbox">
      <div class="icon-wrapper">
        <AppSvgIcon v-if="props.item.selected" name="check" size="18" />
      </div>
    </div>
    <span class="app-multi-select-item-label">{{ props.item.label }}</span>
  </AppRawButton>
</template>

<style lang="scss" scoped>
@use '../../../styles/media' as *;
@use '../../../styles/fonts' as *;

.app-multi-select-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  @include font-label-m-light;

  .app-multi-select-item-label {
    padding: 0 var(--spacing-4);
  }

  .app-multi-select-dropdown-item-checkbox {
    padding: var(--spacing-12);
    .icon-wrapper {
      border-radius: var(--border-radius-4);
      border: 2px solid var(--color-neutral-70);
      width: 20px;
      height: 20px;
    }
  }
  @include on-hover {
    .app-multi-select-dropdown-item-checkbox {
      border-radius: 50%;
      background-color: var(--color-neutral-30);
    }
  }

  &.selected {
    .app-multi-select-dropdown-item-checkbox {
      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--color-neutral-70);
        color: var(--color-white);
      }
    }
    &.disabled {
      .app-multi-select-dropdown-item-checkbox {
        .icon-wrapper {
          background-color: var(--color-neutral-30);
          color: var(--color-white);
          padding: 0;
        }
      }
    }
  }

  &.disabled {
    cursor: default;
    .app-multi-select-item-label {
      color: var(--color-neutral-60);
    }

    .app-multi-select-dropdown-item-checkbox {
      .icon-wrapper {
        border: 2px solid var(--color-neutral-30);
        background-color: var(--color-neutral-30);
      }
    }
    @include on-hover {
      .app-multi-select-dropdown-item-checkbox {
        border-radius: 0%;
        background-color: var(--color-white);
      }
    }
  }
}
</style>
